/**
 * The scheduler's tag grammar, as the UI needs to read it.
 *
 * Tags are `{platform}:{handle}:{kind}` for recurring work and
 * `{platform}:{handle}:{kind}:{from}..[{to}]` for a one-off over a fixed
 * window. The backend owns the grammar (`jobs::scrape_comment_fetch::work_tag`
 * and `job_tag`); these predicates only read it, so the places that used to
 * pattern-match `:monitor` and `:historic_fetch:` agree with each other.
 */

/** The kind behind a Monitor: a recurring Apify scrape. */
export const SCRAPE_COMMENT_FETCH_KIND = 'scrape_comment_fetch'

/** The kinds the fleet passes run as. Both also run per account. */
export const API_POST_FETCH_KIND = 'api_post_fetch'
export const API_COMMENT_FETCH_KIND = 'api_comment_fetch'

/**
 * Any fetch kind's one-off segment: `:{kind}:{YYYY-MM-DD}`.
 */
const ONE_OFF_WINDOW = new RegExp(
    `:(?:${SCRAPE_COMMENT_FETCH_KIND}|api_comment_fetch):\\d{4}-\\d{2}-\\d{2}\\.\\.`
)

/** True for a one-off fetch over a fixed window (a historic fetch). */
export const isOneOffFetchTag = (tag: string): boolean => ONE_OFF_WINDOW.test(tag)

/** True for an account's recurring scrape (its Monitor). */
export const isRecurringScrapeCommentFetchTag = (tag: string): boolean =>
    tag.endsWith(`:${SCRAPE_COMMENT_FETCH_KIND}`)
